import { Box, Grid } from "@mui/material";
import DriverCoachingDashboardHeader from './components/PageHeader';
import DriverCoachingTiles from './components/PageTiles';
import DriverCoachingScoreChart from './components/PageChart';
import DriverCoachingGraph from './components/PageGraph';
import { useState } from "react";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import DriverAlertDataTable from "./components/PageTable";

export default function DriverCoachingDashboard() {
    const today = dayjs();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const driverId: any = params.get('driverId');
    const driverName = params.get('driverName');
    const employeeId = params.get('employeeId');
    const startDate = params.get('startDate');
    const endDate = params.get('endDate');
    const selectedDuration = params.get('selectedDuration');
    const [dateState, setDateState] = useState({ startDate:  startDate ?? today.format("YYYY-MM-DD"), endDate:  endDate ?? today.format("YYYY-MM-DD"), selectedDuration: selectedDuration ?? '' });
    
    return (
        <Box sx={{ flexGrow: 1, mt: 4 }}>
            <DriverCoachingDashboardHeader setDateState={setDateState} driverName={driverName} employeeId={employeeId} previousSelectedDuration={selectedDuration} dateState={dateState}/>
            <Box key={`${dateState.startDate}-${dateState.endDate}`}>
                <DriverCoachingTiles />
                <Grid container spacing={2} sx={{ mt: 4 }}>
                    <Grid item xs={12} sm={6}>
                        <DriverCoachingScoreChart
                            totalDrivers={1002}
                            title="Driver Summary Incident By Critical Alerts"
                            dateState={dateState}
                            driverId={driverId}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {/* <DriverByAlertsGraph driverId={driverId} dateState={dateState} /> */}
                        <DriverCoachingGraph />
                    </Grid>
                </Grid>
                <DriverAlertDataTable />
            </Box>
        </Box>
    );
}